import { render, staticRenderFns } from "./PaginacaoTabela.vue?vue&type=template&id=713da460&scoped=true"
import script from "./PaginacaoTabela.vue?vue&type=script&lang=js"
export * from "./PaginacaoTabela.vue?vue&type=script&lang=js"
import style0 from "./PaginacaoTabela.vue?vue&type=style&index=0&id=713da460&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713da460",
  null
  
)

export default component.exports